import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import useTabs from "../../Hooks/useTabs";
import StatusBadge from "../../UI/StatusBadge/StatusBadge";
import DateService from "../../../Services/Shared/Date.service";
import InfoItems from "../../UI/InfoItems/InfoItems";
import BooleanDisplay from "../../UI/BooleanDisplay/BooleanDisplay";
import { AlertInfo } from "../../UI/StandardAlerts/StandardAlerts";
import ResponsiveTable from "../../UI/ResponsiveTable/ResponsiveTable";
import CustomCard from "../../UI/CustomCard/CustomCard";
const DetailsTab = ({ personApplication }) => {
    const applicationItems = [
        {
            label: "Admit Status",
            value: personApplication.AdmitStatus,
        },
        {
            label: "Residency Status",
            value: personApplication.ResidencyStatus,
        },
        {
            label: "Student Load Intent",
            value: personApplication.StudentLoadIntent,
        },
        {
            label: "Student Type",
            value: personApplication.StudentType,
        },
        { label: "Location", value: personApplication.Locations.join(", ") },
        {
            label: "Financial Aid Intent Flag",
            value: personApplication.FinancialAidIntentFlag !== null ? (_jsx(BooleanDisplay, { val: personApplication.FinancialAidIntentFlag })) : null,
        },
        {
            label: "Financial Aid Submit Date",
            value: personApplication.FinancialAidSentDate
                ? DateService.display(new Date(personApplication.FinancialAidSentDate))
                : "",
        },
    ];
    return (_jsx(InfoItems, { items: applicationItems, numColumnsLg: 3, noItemsComponent: _jsx(AlertInfo, { message: "No details are available for this application" }) }));
};
const HistoryTab = ({ personApplication }) => {
    return (_jsx("div", { className: "mb-3", children: _jsx(ResponsiveTable, { columns: [
                { title: "Date" },
                { title: "Old Status", align: "center" },
                { title: "New Status", align: "center" },
            ], rows: personApplication.History.map((history, index) => [
                _jsx("div", { children: DateService.displayWithTime(Date.parse(history.NewStatusDate)) }, `date-${index}`),
                _jsx(StatusBadge, { badgeColor: history.OldBadgeColor, statusName: history.OldStatus }, `old-${index}`),
                _jsx(StatusBadge, { badgeColor: history.NewBadgeColor, statusName: history.NewStatus }, `new-${index}`),
            ]) }) }));
};
const PersonApplicationCard = ({ personApplication, student }) => {
    var _a;
    const applicationTitle = (_a = personApplication.Program) !== null && _a !== void 0 ? _a : "Application";
    const [tabs, tabContent] = useTabs({
        tabs: [
            {
                tab: "Details",
                content: (_jsx("div", { className: "card-body", children: _jsx(DetailsTab, { personApplication: personApplication, student: student }) })),
            },
            {
                tab: "History",
                content: (_jsx("div", { className: "card-body pt-2", children: _jsx(HistoryTab, { personApplication: personApplication, student: student }) })),
            },
        ],
        className: "pl-3",
        tabStyle: "underline",
    });
    return (_jsxs(CustomCard, { customHeader: _jsxs("div", { className: "card-header bg-white d-flex justify-content-between border-0", children: [_jsxs("div", { children: [_jsx("h4", { className: "card-title mb-0", children: applicationTitle }), _jsx("div", { className: "text-muted", children: personApplication.AcademicYear }), personApplication.ApplicationType && (_jsx("div", { className: "text-muted", children: personApplication.ApplicationType }))] }), _jsxs("div", { className: "d-flex flex-column align-items-center my-1", children: [_jsx(StatusBadge, { badgeColor: personApplication.BadgeColor, statusName: personApplication.Status }), (personApplication.Age || personApplication.Age === 0) && (_jsx("div", { children: _jsxs("small", { className: "text-muted", title: `Started on ${DateService.displayWithTime(
                                // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'Date'.
                                Date.parse(personApplication.StartDate))}`, children: ["Age: ", personApplication.Age, " days"] }) }))] })] }), children: [tabs, tabContent] }));
};
export default PersonApplicationCard;
